function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var TVAddon = function TVAddon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M20.996 3a1.9 1.9 0 0 1 1.899 1.9v8.723h-.012q.083.49.084 1.004a6.006 6.006 0 0 1-7.697 5.755 1 1 0 0 1-.653.242h-5.34a1 1 0 1 1 0-2h1.67v-1.341H2.9a1.9 1.9 0 0 1-1.9-1.9V4.9A1.9 1.9 0 0 1 2.9 3zm-4.029 7.627c-2.205 0-4 1.793-4 4 0 2.205 1.795 4 4 4s4-1.794 4-4-1.794-4-4-4m0 1a1 1 0 0 1 1 1v.999h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1M20.895 5H3v10.282h8.002a6.006 6.006 0 0 1 5.964-6.657c1.5 0 2.874.554 3.927 1.467z"
  }));
};
export default TVAddon;